class YGScriptLoader extends HTMLElement {
  loadScript(url, fn) {
    if (url) {
      let loadScript = document.createElement('script')
      loadScript.src = url
      document.body.appendChild(loadScript)

      loadScript.onload = () => {
        fn()
      }

      loadScript.onerror = (err) => {
        console.error(err)
      }
    }
  }
}

class YGImageSlider extends YGScriptLoader {
  constructor() {
      super();
      const url = this.getAttribute('data-load-script');
      this.sectionId = this.getAttribute('data-section-id');
      // 只有在 design_mode 中才会添加 data-load-script 属性
      if (url) {
          this.loadScript(url, () => {
              this.init();
          });
      } else {
          this.init();
      }
  }

  init() {
      new Swiper(`.yg-slider-${this.sectionId}`, {
          autoHeight: 'auto',
          loop: true,
          spaceBetween: 0,
          breakpoints: {
              1150: {
                  slidesPerView: parseInt(this.getAttribute('data-size')) || 3,
              },
              768: {
                  slidesPerView: 2,
              },
              220: {
                  slidesPerView: 1,
              }
          },
          navigation: {
              nextEl: `.yg-next-${this.sectionId}`,
              prevEl: `.yg-prev-${this.sectionId}`,
          },
      });
  }
}

if (!window.customElements.get('yg-image-slider')) {
  window.customElements.define('yg-image-slider', YGImageSlider);
}

class YGDetails extends HTMLElement {
  constructor() {
    super()
    this.init()
  }
  init() {
    // 这里放置自定义逻辑 
    let YGDetails = this.querySelectorAll('.yg-details')
    YGDetails.forEach((item) => {
      let title = item.querySelector('.yg-details-title');
      let content = item.querySelector('.yg-details-content');
      let btn = item.querySelector('.yg-right svg');
      this.clickTab(title, content, btn);

    })
  }

  clickTab(title, content, btn) {
    // title: title元素
    // content: content元素
    let height = content.offsetHeight + 12;
    content.style.height = '0';

    title.addEventListener("click", function () {
      if (content.classList.contains('active')) {
        content.style.height = '0';
        content.style.paddingTop = '0';
        btn.style.transform = 'none';
        content.classList.remove('active')
      } else {
        content.style.height = `${height}px`;
        content.style.paddingTop = '12px';
        btn.style.transform = 'rotate(180deg)';
        content.classList.add('active');
      }
    })
  }
}
if (!window.customElements.get('yg-details')) {
  window.customElements.define('yg-details', YGDetails)
}

class YGImageWithTextSwiper extends YGScriptLoader {
  constructor() {
    super()
    this.init();
  }

  init() {
    const size = this.getAttribute('data-block-size') || 3;
    const swiper = this.querySelector('.swiper');
    const pagination = this.querySelector('.swiper-pagination');

    new Swiper(swiper, {
      slidesPerView: 1.2,
      spaceBetween: 24,
      pagination: {
        el: pagination,
        type: "progressbar"
      },
      breakpoints: {
        700: {
          slidesPerView: size
        }
      }
    })
  }
}

if (!window.customElements.get('yg-image-width-text-swiper')) {
  window.customElements.define('yg-image-width-text-swiper', YGImageWithTextSwiper);
}

document.addEventListener('DOMContentLoaded', function () {
  class YGAnchorButton extends HTMLElement {
    constructor() {
      super()
      this.init()
      this.style.display = 'block'
    }

    init() {
      const $button = this;
      const order = $button.getAttribute("data-section-order");
      const ygSectionList = document.querySelectorAll('#main .shopify-section');

      $button.addEventListener("click", function (e) {
        e.preventDefault()

        const section = ygSectionList[order - 1]
        if (section) {
          console.log(section.offsetTop);
          
          window.scrollTo({
            top: section.offsetTop - 134,
            behavior: "smooth"
          })
        }
      })
    }
  }

  if (!window.customElements.get('yg-anchor-button')) {
    window.customElements.define('yg-anchor-button', YGAnchorButton);
  }
})